import type {DealFeatureFlags} from 'Types/deals/dealFeatureFlags';

/**
 * Returns true if a free shares incentive tier is enabled for the given deal
 * flags
 *
 * @param {DealFeatureFlags} dealFlags the deal flags to derive the return
 */
export const freeSharesEnabled = (dealFlags: DealFeatureFlags): boolean => {
  return !!(
    dealFlags.enhanced_perks_free_shares_enabled ||
    dealFlags.enhanced_perks_free_shares_codes_enabled
  );
};

export const timeEnabled = (dealFlags: DealFeatureFlags): boolean => {
  return !!dealFlags.enhanced_perks_time_enabled;
};

export const loyaltyEnabled = (dealFlags: DealFeatureFlags): boolean => {
  return !!dealFlags.enhanced_perks_loyalty_enabled;
};

export const volumeEnabled = (dealFlags: DealFeatureFlags): boolean => {
  return !!dealFlags.enhanced_perks_volume_enabled;
};

/**
 * Returns true if any kind of incentive tiers are enabled for the given deal
 * flags
 *
 * @param {DealFeatureFlags} dealFlags the deal flags to derive the return
 */
export const incentiveTiersEnabled = (dealFlags: DealFeatureFlags): boolean => {
  return (
    freeSharesEnabled(dealFlags) ||
    timeEnabled(dealFlags) ||
    loyaltyEnabled(dealFlags) ||
    volumeEnabled(dealFlags)
  );
};
